module.exports = __webpack_public_path__ + "img/jesus.d3e510b4.png";